<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3 ">
            <el-form class="demo-form-inline">
              <div class="uers-left">
                <el-form-item>
                  微站地址：
                  <el-tag type="primary">{{ url }}</el-tag>
                </el-form-item>
              </div>
              <div class="uers-right">
                <span class="btn-r">
                  <el-button
                      style="float: right; margin-left: 10px"
                      type="primary"
                      plain
                      icon="el-icon-plus"
                      @click="addSubmit"
                  >新增</el-button
                  >
                </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="table"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="type"
                  label="类型"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{
                      scope.row.type == 1
                          ? "1张大图按钮"
                          : scope.row.type == 2
                              ? "2张图片按钮"
                              : scope.row.type == 3
                                  ? "3张图片按钮"
                                  : scope.row.type == 4
                                      ? "4张图片按钮"
                                      : scope.row.type == 5
                                          ? "5张图片按钮"
                                          : scope.row.type == 0
                                              ? "首页轮播图"
                                              : scope.row.type == 7
                                                  ? "推荐展品"
                                                  : scope.row.type == 8
                                                      ? "推荐展商"
                                                      : scope.row.type == 6
                                                          ? "图文板块"
                                                          : "其他"
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="indexNo"
                  label="排序"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.indexNo }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="indexNo"
                  label="启用"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.required == 0 ? "否" : "是" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="options"
                  label="分组"
                  width="200"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.options }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="名称"
                  width="200"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="img"
                  label="图片"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.img"
                        :preview-src-list="[scope.row.img]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="url" label="Url地址" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.url }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditProjectProperty
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditProjectProperty>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditProjectProperty from "../../components/major/EditProjectProperty";
import DeleteDialog from "../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      ProjectProperty_Id: "",
      url:
          localStorage.getItem("url").replace("/api", "/wechat/metting/") +
          localStorage.getItem("project_Id"),
    };
  },
  mounted() {
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.getData();
  },
  methods: {
    open(url) {
      window.open(url);
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
      this.getData();
    },
    addSubmit() {
      this.projectPropertyId = "";
      this.listShow = false;
      this.editShow = true;
      this.editData = {};
    },
    handleDelete(index, row) {
      this.projectPropertyId = row.projectPropertyId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.projectPropertyId = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios
          .delete(`/ProjectProperty/${this.projectPropertyId}`)
          .then((res) => {
            if (res.data.hasError) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success("删除成功！");
              this.delVisible = false;
              this.getData();
            }
          });
    },
    // 获取数据
    getData() {
      this.$axios.get("/ProjectProperty/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    getFunStu() {
      this.editData = null;
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditProjectProperty,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-right {
  float: right;
}

.uers-left {
  float: left;
}

.table-wrap {
  overflow-y: auto !important;
}

.uers-right-buttom {
  margin-bottom: 19px;
}

.handle-bottom {
  padding-bottom: 20px;
}

.import-bnt {
  float: right;
}

.el-upload--text {
  border: 0;
}
</style>